<template>
    <div style="min-height: 200px">
        <div class="table-responsive">
            <table id="trial" class="table table-bordered">
                <thead>
                    <tr>
                        <th>Accounts Type</th>
                        <th>Group level 1</th>
                        <th>Group level 2</th>
                        <th>Group level 3</th>
                        <th>Group level 4</th>
                        <th>Accounts Head</th>
                        <!-- <th class="text-end">Opening</th>
                        <th class="text-end">Movement</th>
                        <th class="text-end">Closing</th> -->
                        <th class="text-end">Debit</th>
                        <th class="text-end">Credit</th>
                    </tr>
                </thead>
                
                <tbody v-if="balances.length">
                    <tr v-for="(item, i) in balances" :key="i">
                        <td>{{ item.account_type }}</td>
                        <td>{{ withCode(item.account_level_1_name, item.account_level_1_code) }}</td>
                        <td>{{ withCode(item.account_level_2_name, item.account_level_2_code) }}</td>
                        <td>{{ withCode(item.account_level_3_name, item.account_level_3_code) }}</td>
                        <td>{{ withCode(item.account_level_4_name, item.account_level_4_code) }}</td>
                        <td>{{ withCode(item.account_head_name, item.account_head_code) }}</td>
                        <!-- <td class="text-end">{{ item.opening ? commaFormat(item.opening) : 0 }}</td>
                        <td class="text-end">{{ item.movement ? commaFormat(item.movement) : 0 }}</td>
                        <td class="text-end">{{ item.balance ? commaFormat(item.balance) : 0 }}</td> -->
                        <td
                            class="text-end"
                            :class="{ 'ledger-link': item.account_head_id }"
                            :role="item.account_head_id ? 'button' : null"
                            :title="item.account_head_id ? 'View General Ledger' : null"
                            @click="goToGeneralLedger(item.account_head_id)"
                        >
                            {{ item.debit ? commaFormat(item.debit) : 0 }}
                        </td>
                        <td
                            class="text-end"
                            :class="{ 'ledger-link': item.account_head_id }"
                            :role="item.account_head_id ? 'button' : null"
                            :title="item.account_head_id ? 'View General Ledger' : null"
                            @click="goToGeneralLedger(item.account_head_id)"
                        >
                            {{ item.credit ? commaFormat(item.credit) : 0 }}
                        </td>
                    </tr>
                    <tr class="bg-blue-light">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><strong>TOTAL</strong></td>
                        <!-- <td class="text-end">{{ commaFormat(getTotal('opening')) }}</td>
                        <td class="text-end">{{ commaFormat(getTotal('movement')) }}</td>
                        <td class="text-end">{{ commaFormat(getTotal('balance')) }}</td> -->
                        <td class="text-end">{{ commaFormat(getTotal('debit')) }}</td>
                        <td class="text-end">{{ commaFormat(getTotal('credit')) }}</td>
                    </tr>
                </tbody>
            </table>
            <p v-if="!balances.length" class="mt-5 text-center">No data</p>
        </div>
    </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import figureFormatter from '@/services/utils/figureFormatter'
export default {
    name: 'TrialBalanceTable',
    props: {
        acName: String,
        balances: {
            default: [],
            type: Array
        }
    },
    methods: {
        withCode (name, code) {
            if (!name) return ''
            if (!code) return name
            return `${name} (${code})`
        },
        getTotal (key) {
            let total = 0;
            this.balances.map(i => {
                if(i[key]) {
                    total += i[key]
                }
            })
            return total
        }, 
    },
    setup() {
        const {commaFormat} = figureFormatter ()
        const route = useRoute()
        const router = useRouter()

        const goToGeneralLedger = (headId) => {
            if (!headId) return
            const query = Object.assign({}, route.query, { headId })
            const routeData = router.resolve({
                name: 'general-ledger',
                params: {
                    companyId: route.params.companyId,
                    moduleId: route.params.moduleId,
                    menuId: route.params.menuId,
                    pageId: route.params.pageId
                },
                query
            })
            window.open(routeData.href, '_blank')
        }

        return {
            commaFormat,
            goToGeneralLedger
        }
    },
}
</script>

<style scoped>
#trial td{
    padding: 2px
}
#trial th{
    padding: 10px 3px;
}
#trial td.ledger-link {
    color: #000;
    font-weight: 600;
    cursor: pointer;
}
#trial td.ledger-link:hover {
    text-decoration: underline;
}
</style>
